import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import {
  PERMISSION_GROUP_KIND,
  PERMISSION_GROUP_KIND_ADMIN,
  PERMISSION_GROUP_KIND_DEFAULT,
} from 'modules/permissions/lib/constants'
import PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

class PermissionGroups extends Collection<PermissionGroup> {
  constructor(data: Array<PermissionGroup> = []) {
    super(data)
    makeObservable(this, {
      adminGroup: computed,
      basicGroup: computed,
      defaultGroup: computed,
    })
  }

  get cacheKey(): string {
    return 'permissionGroups'
  }

  model() {
    return PermissionGroup
  }

  get adminGroup(): PermissionGroup | null | undefined {
    return this.find((group) => {
      if (group.has(PERMISSION_GROUP_KIND)) {
        return group.get(PERMISSION_GROUP_KIND) === PERMISSION_GROUP_KIND_ADMIN
      }
      return group.get('legacy_admin') === true
    })
  }

  get basicGroup(): PermissionGroup | null | undefined {
    return this.find((group) => {
      if (group.has(PERMISSION_GROUP_KIND)) {
        return group.get(PERMISSION_GROUP_KIND) !== PERMISSION_GROUP_KIND_ADMIN
      }
      return group.get('legacy_admin') === false
    })
  }

  get defaultGroup(): PermissionGroup | null | undefined {
    return this.find((group) => {
      if (group.has(PERMISSION_GROUP_KIND)) {
        return group.get(PERMISSION_GROUP_KIND) === PERMISSION_GROUP_KIND_DEFAULT
      }
      return group.get('default_group') === true
    })
  }
}

const singleton: PermissionGroups = new PermissionGroups()

export default singleton
